export const FETCH_CONFIGS = 'FETCH_CONFIGS';
export const FETCH_CAMERA = 'FETCH_CAMERA';
